import React, { useState, useEffect } from 'react';

import AuthHeader from './../components/Layout/AuthHeader';
import Moved from './../components/Dashboard/Moved';
import Footer from './../components/Layout/Footer';
import { getUserApi } from './../requests';
import { setUserStorage } from './../utils/storage';

export default () => {
  const [user, setUser] = useState();

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    const user = await getUserApi();
    setUserStorage(user);
    setUser(user);
  }

  return user ? (
    <>
      <main>
        <AuthHeader/>
        <Moved/>
        <Footer/>
      </main>
    </>
  ) : null;
}
